import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { ZErrorResponseSchema, ZProfileResponseSchema } from './models';

const c = initContract();

export const authAuthContract = c.router(
  {
    profile: {
      method: 'GET',
      path: '/profile',
      responses: {
        200: ZProfileResponseSchema,
        400: ZErrorResponseSchema,
        401: ZErrorResponseSchema,
        404: ZErrorResponseSchema,
      },
      summary: 'Returns a player object from the extracted JWT token',
    },
  },
  {
    pathPrefix: '/auth',
    commonResponses: {
      401: c.type<{ message: 'Unauthorized'; statusCode: 401 }>(),
    },
  }
);
